import React, { useState } from "react";
import { FaTachometerAlt, FaFolderOpen, FaClipboardList, FaUser, FaCreditCard } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import CustomModal from "./CustomModal";
import "../styles/Dashboard.css";

export default function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [showSignOutModal, setShowSignOutModal] = useState(false);
  const [modalState, setModalState] = useState({
    isOpen: false,
    title: "",
    message: "",
    type: "info",
    onConfirm: null
  });

  const handleSignOutClick = () => {
    setShowSignOutModal(true);
  };

  const confirmSignOut = async () => {
    try {
      await logout();
      navigate("/login");
    } catch (error) {
      console.error("Error signing out:", error);
      setModalState({
        isOpen: true,
        title: "Sign Out Failed",
        message: "Failed to sign out. Please try again.",
        type: "error",
        onConfirm: () => setModalState(prev => ({ ...prev, isOpen: false }))
      });
    } finally {
      setShowSignOutModal(false);
    }
  };

  const handleLogoClick = () => {
    navigate("/dashboard");
  };

  const menuItems = [
    { name: "Dashboard", icon: <FaTachometerAlt />, path: "/dashboard", external: false },
    {
      name: "Available Projects",
      icon: <FaFolderOpen />,
      path: "/available-projects",
      external: false
    },
    {
      name: "My Projects",
      icon: <FaClipboardList />,
      path: "/my-projects",
      external: false
    },
    { name: "Profile", icon: <FaUser />, path: "/profile", external: false },
    { name: "Payments", icon: <FaCreditCard />, path: "/payments", external: false }
  ];

  return (
    <div className="sidebar">
      <div>
        <div className="logo-container" onClick={handleLogoClick}>
          <img src="/orvion-logo.png" alt="Orvion Logo" className="logo-image" />
          <h2 className="logo">Orvion Studio</h2>
        </div>
        <nav>
          {menuItems.map((item) => (
            <a
              key={item.name}
              href={item.path}
              className={!item.external && location.pathname === item.path ? "active" : ""}
              target={item.external ? "_blank" : "_self"}
              rel={item.external ? "noopener noreferrer" : ""}
            >
              {item.icon}
              {item.name}
            </a>
          ))}
        </nav>
      </div>

      <button className="signout-btn" onClick={handleSignOutClick}>Sign Out</button>

      {/* Sign Out Confirmation Modal */}
      <CustomModal
        isOpen={showSignOutModal}
        onClose={() => setShowSignOutModal(false)}
        title="Sign Out"
        message="Are you sure you want to sign out?"
        type="danger"
        confirmText="Sign Out"
        cancelText="Cancel"
        onConfirm={confirmSignOut}
      />

      {/* Error Modal */}
      <CustomModal
        isOpen={modalState.isOpen}
        onClose={() => setModalState(prev => ({ ...prev, isOpen: false }))}
        title={modalState.title}
        message={modalState.message}
        type={modalState.type}
        onConfirm={modalState.onConfirm}
      />

    </div>
  );
}
